/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Get_Started_LabelInputs */

const en_faq_get_started_label = /** @type {(inputs: Faq_Get_Started_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started with Listening`)
};

const es_faq_get_started_label = /** @type {(inputs: Faq_Get_Started_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comienza con Listening`)
};

/**
* | output |
* | --- |
* | "Get started with Listening" |
*
* @param {Faq_Get_Started_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_get_started_label = /** @type {((inputs?: Faq_Get_Started_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Get_Started_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_get_started_label(inputs)
	return en_faq_get_started_label(inputs)
});